/*
 * Florafy storefront loader. Included by snippets/posthog.liquid.
 *
 * This is the Florafy PostHog organization, not Green Bubble's. The API host
 * is the Florafy reverse proxy (https://ingest.florafy.eu). The browser must
 * not call PostHog's public ingestion domain: iOS and ad blockers drop it.
 *
 * ui_host stays https://eu.posthog.com so the toolbar can link back to the
 * Florafy project. capture_performance stays off: GTM already owns web vitals
 * for this shop, and a second performance stream would disagree with it.
 * Request tracing stays unset so PostHog does not stamp its own proxy calls.
 *
 * CONSENT: PostHog is not loaded until analytics consent is given. Cookiebot
 * (statistics, and a real response) and Shopify's analyticsProcessingAllowed()
 * must both allow it. Either signal missing keeps the library unloaded.
 * After load it starts opted out and follows later choices in both directions.
 *
 * Cart and checkout events are not sent from here. They come from the custom
 * web pixel in docs/posthog-web-pixel.js. Sending them here as well counts
 * every cart add twice.
 */
(function () {
  var script = document.currentScript;
  var key = script && script.dataset.key;
  if (!key) return;
  var host = script.dataset.host || 'https://ingest.florafy.eu';
  // Customer id only, never the email: PostHog does not need PII.
  var customerId = script.dataset.customer || '';

  // Official PostHog loader stub (posthog.com/docs/libraries/js), unchanged.
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

  function applyConsent(ph, allowed) {
    if (allowed) {
      if (!ph.has_opted_in_capturing()) ph.opt_in_capturing({ captureEventName: false });
      if (customerId) ph.identify(customerId);
    } else if (!ph.has_opted_out_capturing()) {
      ph.opt_out_capturing();
    }
  }

  function shopifyAllows() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
      privacy.analyticsProcessingAllowed());
  }

  function cookiebotAllows() {
    var cookiebot = window.Cookiebot;
    return !!(cookiebot && cookiebot.hasResponse && cookiebot.consent && cookiebot.consent.statistics);
  }

  function analyticsAllowed() {
    return shopifyAllows() && cookiebotAllows();
  }

  var started = false;
  var instance = null;
  function start() {
    if (started) return;
    started = true;

    window.posthog.init(key, {
      api_host: host,
      ui_host: 'https://eu.posthog.com',
      defaults: '2026-05-30',
      person_profiles: 'identified_only',
      capture_performance: false,
      // Scroll depth arrives on $pageleave ($prev_pageview_max_scroll_percentage).
      capture_pageleave: true,
      // Click maps; the heatmaps toggle in the Florafy project must be on too.
      enable_heatmaps: true,
      // Same cookie on florafy.eu and zakelijk.florafy.eu, so checkout keeps the visitor.
      cross_subdomain_cookie: true,
      opt_out_capturing_by_default: true,
      // Stamps the producer on every event. before_send is part of the init
      // config, so it also covers events captured before `loaded` runs and
      // replay $snapshot envelopes, which register() does not reach. A
      // caller-supplied `app` is overwritten, so it cannot spoof the producer.
      before_send: function (event) {
        if (!event) return event;
        event.properties = event.properties || {};
        event.properties.app = 'florafy';
        return event;
      },
      loaded: function (ph) {
        ph.register({ channel: 'b2c' });
        // A customer logged out, but the cookie still carries their identity.
        // Without this the next visitor on a shared device, including their
        // checkout (the web pixel reads the same cookie), lands on that customer.
        if (!customerId && ph.get_property('$user_state') === 'identified') ph.reset();

        instance = ph;
        applyConsent(ph, analyticsAllowed());
      },
    });
  }

  function onConsentChange() {
    if (instance) {
      applyConsent(instance, analyticsAllowed());
    } else if (analyticsAllowed()) {
      start();
    }
  }

  document.addEventListener('visitorConsentCollected', onConsentChange);
  window.addEventListener('CookiebotOnConsentReady', onConsentChange);
  window.addEventListener('CookiebotOnAccept', onConsentChange);
  window.addEventListener('CookiebotOnDecline', onConsentChange);

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error) return;
    onConsentChange();
  });
})();
